import { useEffect, useMemo, useRef, useState } from "react";
import PageLayout from "@/components/feature/PageLayout";
import HomeFooter from "@/pages/home/components/HomeFooter";
import DiagnosisSection from "@/pages/home/components/DiagnosisSection";
import DiagonalLines from "@/components/feature/DiagonalLines";

const services = [
  {
    num: "01",
    title: "ホームページ制作",
    tocName: "ホームページ制作",
    icon: "ri-computer-line",
    lead: "「見た目がいい」だけでは売上は変わりません。",
    body: "クラプクリックスのホームページ制作は、デザインの美しさと「成果」を両立することを最優先に考えています。お客様の事業目標・ターゲット・競合を徹底的に分析したうえで、コーディング・CMS構築まで一貫して制作します。",
    tag: "WEB DESIGN",
    img: "https://readdy.ai/api/search-image?query=professional%20Japanese%20web%20designer%20working%20at%20clean%20minimalist%20desk%20with%20MacBook%20laptop%20showing%20modern%20website%20in%20soft%20neutral%20warm%20white%20toned%20office%20interior%20with%20natural%20daylight%20wooden%20desk%20and%20green%20plants%20professional%20workspace%20photography%20clean%20off-white%20background%20real%20photo%20style&width=1200&height=700&seq=svc-beige-01&orientation=landscape",
  },
  {
    num: "02",
    title: "SEO対策",
    tocName: "SEO対策",
    icon: "ri-search-2-line",
    lead: "検索上位に表示されることが、最も費用対効果の高い集客です。",
    body: "広告費をかけなくても自然検索から継続的に集客できる仕組みをつくることが、SEO対策の本質です。競合サイトの分析・キーワード選定・コンテンツ制作まで、データに基づいた戦略で検索順位の向上をサポートします。",
    tag: "SEO",
    img: "https://readdy.ai/api/search-image?query=professional%20SEO%20analyst%20working%20on%20laptop%20with%20search%20analytics%20dashboard%20showing%20upward%20trending%20graphs%20in%20soft%20neutral%20warm%20white%20toned%20office%20with%20natural%20daylight%20modern%20minimalist%20workspace%20data%20analysis%20clean%20off-white%20background%20photography%20real%20photo&width=1200&height=700&seq=svc-beige-02&orientation=landscape",
  },
  {
    num: "03",
    title: "MEO対策",
    tocName: "MEO対策",
    icon: "ri-map-pin-2-line",
    lead: "「地域名＋業種」で検索されたとき、あなたのお店は上位に出てきますか？",
    body: "Googleマップの検索結果で上位表示されることは、来店・予約・問い合わせに直結します。口コミ管理・写真最適化・情報整備など、地域密着型ビジネスの集客を根本から強化します。",
    tag: "LOCAL SEO",
    img: "https://readdy.ai/api/search-image?query=Japanese%20local%20cafe%20shop%20exterior%20with%20Google%20Maps%20pin%20overlay%20in%20soft%20neutral%20warm%20white%20tones%20with%20natural%20daylight%20small%20business%20storefront%20urban%20street%20photography%20clean%20off-white%20background%20professional%20real%20photo%20style&width=1200&height=700&seq=svc-beige-03&orientation=landscape",
  },
  {
    num: "04",
    title: "LLMO対策",
    tocName: "LLMO対策",
    icon: "ri-robot-line",
    lead: "「ChatGPTやGeminiに聞いたら、競合が出てきた」という時代が来ています。",
    body: "検索エンジンだけでなく、AIが情報源として参照するサイトになることが、これからの集客の新しい競争軸です。クラプクリックスでは、AIに引用・紹介されやすいコンテンツ構造・情報設計を意識したサイト制作で、生成AI時代の集客基盤をつくります。",
    tag: "LLMO",
    img: "https://readdy.ai/api/search-image?query=person%20using%20AI%20chatbot%20on%20smartphone%20in%20soft%20neutral%20warm%20white%20toned%20office%20with%20natural%20daylight%20ChatGPT%20Gemini%20interface%20on%20screen%20technology%20lifestyle%20photography%20clean%20off-white%20background%20professional%20real%20photo&width=1200&height=700&seq=svc-beige-04&orientation=landscape",
  },
  {
    num: "05",
    title: "自社アプリ制作",
    tocName: "アプリ制作",
    icon: "ri-smartphone-line",
    lead: "「アプリがあれば」と思ったことはありませんか？",
    body: "予約・会員管理・ポイント機能・プッシュ通知など、ホームページではできないことがアプリなら実現できます。お客様のビジネスモデルに合わせてiOS・Android両対応のアプリを制作し、顧客との接点をより深いものにします。",
    tag: "APP DEV",
    img: "https://readdy.ai/api/search-image?query=Japanese%20person%20holding%20modern%20smartphone%20showing%20mobile%20app%20interface%20in%20warm%20golden%20cream%20tones%20soft%20natural%20lighting%20lifestyle%20technology%20photography%20clean%20background%20warm%20off-white%20professional%20photo%20style&width=1200&height=700&seq=svc-gold-05&orientation=landscape",
  },
  {
    num: "06",
    title: "リスティング広告",
    tocName: "リスティング広告",
    icon: "ri-megaphone-line",
    lead: "「今すぐ欲しい」人に、確実にリーチできる広告です。",
    body: "リスティング広告は、検索したその瞬間に広告を表示できるため、購買意欲の高いユーザに直接アプローチできます。キーワード選定・広告文作成・入札調整・効果測定まで一貫して運用し、広告費の無駄を徹底的に削減します。",
    tag: "LISTING ADS",
    img: "https://readdy.ai/api/search-image?query=professional%20marketing%20manager%20analyzing%20search%20advertising%20campaign%20on%20laptop%20screen%20showing%20Google%20Ads%20dashboard%20in%20soft%20neutral%20warm%20white%20toned%20office%20with%20natural%20daylight%20modern%20workspace%20photography%20clean%20off-white%20background%20real%20photo&width=1200&height=700&seq=svc-beige-06&orientation=landscape",
  },
  {
    num: "07",
    title: "SNS広告・インフルエンサーマーケティング",
    tocName: "SNS広告",
    icon: "ri-instagram-line",
    lead: "人の言葉と、ターゲットへの精密な配信が、売上を動かします。",
    body: "InstagramやTikTokのSNS広告は、年齢・性別・興味関心など細かいターゲット設定で理想の顧客に直接届けられます。さらにインフルエンサーとのタイアップを組み合わせることで、広告では届かない層への認知拡大も実現。企画・配信・効果測定まで丸ごとお任せください。",
    tag: "SNS / INFLUENCER",
    img: "https://readdy.ai/api/search-image?query=young%20Japanese%20influencer%20creating%20social%20media%20content%20with%20smartphone%20on%20tripod%20in%20soft%20neutral%20warm%20white%20toned%20modern%20studio%20with%20natural%20daylight%20Instagram%20TikTok%20content%20creation%20lifestyle%20photography%20clean%20off-white%20background%20real%20photo%20style&width=1200&height=700&seq=svc-beige-07&orientation=landscape",
  },
];

/* ── Triangle Approach Section ── */
function TriangleApproach() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState<string | null>(null);
  const [drawn, setDrawn] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (visible) {
      const t = setTimeout(() => setDrawn(true), 150);
      return () => clearTimeout(t);
    }
  }, [visible]);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const triNodes = [
    { id: "svc-01", num: "01", label: "Create", scrollTarget: "svc-01", cx: 0, cy: -1 },
    { id: "svc-02", num: "02", label: "Optimize", scrollTarget: "svc-02", cx: 0.87, cy: 0.5 },
    { id: "svc-06", num: "03", label: "Grow", scrollTarget: "svc-06", cx: -0.87, cy: 0.5 },
  ];

  const VW = 1000;
  const VH = 900;
  const cx = VW / 2;
  const cy = VH / 2 + 20;
  const R = 240;
  const blobR = 180;

  const blobs = useMemo(
    () => triNodes.map((n) => ({ ...n, bx: cx + R * n.cx, by: cy + R * n.cy })),
    [cx, cy]
  );

  const triR = R + blobR * 0.5;
  const triPts = triNodes.map((n) => ({ x: cx + triR * n.cx, y: cy + triR * n.cy }));

  function roundedTriPath(pts: { x: number; y: number }[], r: number) {
    const n = pts.length;
    let d = "";
    for (let i = 0; i < n; i++) {
      const prev = pts[(i - 1 + n) % n];
      const curr = pts[i];
      const next = pts[(i + 1) % n];
      const d1x = curr.x - prev.x; const d1y = curr.y - prev.y;
      const d2x = next.x - curr.x; const d2y = next.y - curr.y;
      const len1 = Math.sqrt(d1x * d1x + d1y * d1y);
      const len2 = Math.sqrt(d2x * d2x + d2y * d2y);
      const t = Math.min(r / len1, 0.42);
      const t2 = Math.min(r / len2, 0.42);
      const p1x = curr.x - d1x * t; const p1y = curr.y - d1y * t;
      const p2x = curr.x + d2x * t2; const p2y = curr.y + d2y * t2;
      if (i === 0) d += `M${p1x},${p1y}`;
      else d += `L${p1x},${p1y}`;
      d += `Q${curr.x},${curr.y} ${p2x},${p2y}`;
    }
    return d + "Z";
  }

  const outerPath = roundedTriPath(triPts, 120);

  return (
    <div
      ref={sectionRef}
      className="relative"
      style={{
        background: "#f5f4f2",
        borderBottom: "1px solid rgba(0,0,0,0.07)",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 0.7s cubic-bezier(0.22,1,0.36,1), transform 0.7s cubic-bezier(0.22,1,0.36,1)",
        overflow: "hidden",
      }}
    >
      {/* 流れる背景文字 */}
      <div className="absolute top-0 left-0 right-0 pointer-events-none overflow-hidden" style={{ zIndex: 0, height: "clamp(100px, 12vw, 160px)" }}>
        <div
          className="whitespace-nowrap flex items-start h-full -mt-3"
          style={{
            fontFamily: "'Barlow', sans-serif",
            fontSize: "clamp(80px, 11vw, 160px)",
            fontWeight: 700,
            color: "rgba(0,0,0,0.025)",
            letterSpacing: "0.04em",
            animation: "scrollText 20s linear infinite",
            lineHeight: 1,
          }}
        >
          CRUPLIX SERVICE&nbsp;&nbsp;&nbsp;CRUPLIX SERVICE&nbsp;&nbsp;&nbsp;CRUPLIX SERVICE&nbsp;&nbsp;&nbsp;CRUPLIX SERVICE&nbsp;&nbsp;&nbsp;CRUPLIX SERVICE&nbsp;&nbsp;&nbsp;CRUPLIX SERVICE&nbsp;&nbsp;&nbsp;
        </div>
      </div>
      <div className="max-w-[1300px] mx-auto px-6 md:px-10 lg:px-20 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* SVG Diagram */}
          <div className="w-full lg:w-[55%] overflow-hidden">
            <svg
              viewBox={`0 0 ${VW} ${VH}`}
              preserveAspectRatio="xMinYMid meet"
              style={{ width: "108%", marginLeft: "-8%", height: "auto", display: "block" }}
            >
              <defs>
                <pattern id="svc-hatch" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
                  <line x1="0" y1="0" x2="0" y2="8" stroke="rgba(0,0,0,0.04)" strokeWidth="0.8" />
                </pattern>
              </defs>
              <path d={outerPath} fill="url(#svc-hatch)" stroke="none" opacity={drawn ? 0.4 : 0} style={{ transition: "opacity 0.5s ease 0.3s" }} />
              <path
                d={outerPath} fill="none"
                stroke={hovered ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.12)"}
                strokeWidth="1" strokeDasharray="2800"
                strokeDashoffset={drawn ? "0" : "2800"}
                style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.77,0,0.175,1) 0.1s, stroke 0.3s ease" }}
              />
              {blobs.map((b, bi) => {
                const isHov = hovered === b.id;
                const circumference = 2 * Math.PI * blobR;
                return (
                  <g key={b.id} style={{ cursor: "pointer" }}
                    onClick={() => scrollTo(b.scrollTarget)}
                    onMouseEnter={() => setHovered(b.id)}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <circle cx={b.bx} cy={b.by} r={blobR}
                      fill={isHov ? "rgba(192,0,0,0.15)" : "rgba(0,0,0,0.04)"}
                      style={{ transition: "fill 0.45s ease" }}
                    />
                    <circle cx={b.bx} cy={b.by} r={blobR} fill="none"
                      stroke={isHov ? "#c00000" : "rgba(0,0,0,0.18)"}
                      strokeWidth={isHov ? 1.5 : 1}
                      strokeDasharray={`${circumference}`}
                      strokeDashoffset={drawn ? "0" : `${circumference}`}
                      style={{ transition: `stroke-dashoffset 0.7s cubic-bezier(0.77,0,0.175,1) ${0.1 + bi * 0.1}s, stroke 0.3s ease, stroke-width 0.3s ease` }}
                    />
                    <text x={b.bx} y={b.by - 72} textAnchor="middle"
                      style={{ fontFamily: "'Barlow', sans-serif", fontSize: "16px", fontWeight: 500, letterSpacing: "0.15em", fill: "#c00000" }}
                    >{b.num}</text>
                    <line x1={b.bx - 16} y1={b.by - 60} x2={b.bx + 16} y2={b.by - 60}
                      stroke="#c00000" strokeWidth="1"
                      opacity={drawn ? 1 : 0}
                      style={{ transition: `opacity 0.4s ease ${0.3 + bi * 0.08}s` }}
                    />
                    <text x={b.bx} y={b.by - 14} textAnchor="middle"
                      style={{ fontFamily: "'Barlow', sans-serif", fontSize: "44px", fontWeight: 600, letterSpacing: "-0.01em", fill: isHov ? "#c00000" : "#111111", transition: "fill 0.35s ease" }}
                    >{b.label}</text>
                    <circle cx={b.bx} cy={b.by + 58} r="18"
                      fill={isHov ? "rgba(192,0,0,0.2)" : "rgba(0,0,0,0.04)"}
                      stroke={isHov ? "#c00000" : "rgba(0,0,0,0.2)"} strokeWidth="1"
                      style={{ transition: "stroke 0.35s ease, fill 0.35s ease" }}
                    />
                    <text x={b.bx} y={b.by + 65} textAnchor="middle"
                      style={{ fontFamily: "'Barlow', sans-serif", fontSize: "18px", fill: isHov ? "#c00000" : "#111111", transition: "fill 0.35s ease" }}
                    >↓</text>
                  </g>
                );
              })}
            </svg>
          </div>

          {/* Text side */}
          <div className="flex flex-col gap-8 w-full lg:w-[42%]">
            <div className="flex flex-col gap-6">
              {[
                { num: "01", label: "Create", text: "ホームページ・アプリ制作で、事業の土台となるデジタル資産をつくる。", hoverMatch: "svc-01" },
                { num: "02", label: "Optimize", text: "SEO・MEO・LLMOで、検索エンジンにもAIにも強いサイトへと磨き上げる。", hoverMatch: "svc-02" },
                { num: "03", label: "Grow", text: "リスティング広告・SNS広告・インフルエンサー施策で、見込み客へ確実にリーチする。", hoverMatch: "svc-06" },
              ].map((item) => {
                const isActive = hovered === item.hoverMatch;
                return (
                  <div
                    key={item.num}
                    style={{
                      opacity: hovered ? (isActive ? 1 : 0.3) : 1,
                      transform: isActive ? "translateX(8px)" : "translateX(0)",
                      transition: "opacity 0.45s ease, transform 0.45s cubic-bezier(0.22,1,0.36,1)",
                    }}
                  >
                    <h4
                      style={{
                        fontFamily: "'Barlow', sans-serif",
                        fontSize: "clamp(20px, 2.8vw, 30px)",
                        fontWeight: 600,
                        color: isActive ? "#c00000" : hovered ? "#aaaaaa" : "#c00000",
                        letterSpacing: "0.06em",
                        marginBottom: "6px",
                        transition: "color 0.4s ease",
                      }}
                    >
                      {item.num} {item.label}
                    </h4>
                    <p style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "clamp(13px, 1.4vw, 17px)", color: "#111111", lineHeight: 1.9 }}>{item.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Approach Section ── */
function ApproachSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="relative py-16 md:py-24 lg:py-32 overflow-hidden" style={{ background: "#f5f4f2" }}>
      <div
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(30px)",
          transition: "opacity 0.8s cubic-bezier(0.22,1,0.36,1), transform 0.8s cubic-bezier(0.22,1,0.36,1)",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* タイトル部分 - max-w制限なしで左寄せ */}
        <div className="px-6 md:px-10 lg:px-20">
          <div className="text-left mb-10 md:mb-16">
            <div className="flex flex-wrap items-center gap-3 md:gap-4">
              <h2
                className="font-bold leading-tight w-full"
                style={{
                  fontFamily: "'Barlow', sans-serif",
                  fontSize: "clamp(22px, 4vw, 42px)",
                  color: "#111111",
                  letterSpacing: "-0.02em",
                }}
              >
                集客・制作・広告・AI対策
              </h2>
              <div className="flex items-center gap-3 md:gap-4 w-full">
                <p
                  className="font-bold leading-relaxed"
                  style={{
                    fontFamily: "'Noto Sans JP', sans-serif",
                    fontSize: "clamp(16px, 2.2vw, 24px)",
                    color: "#111111",
                  }}
                >
                  点でやっていては、成果は出ません。
                </p>
                <div style={{ width: "44px", height: "3px", background: "#c00000", flexShrink: 0 }} />
              </div>
            </div>
          </div>
        </div>

        {/* 下の文章 - max-w-[1100px] で右寄せ */}
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-0">
          <div className="text-left md:text-right ml-0 md:ml-auto w-full md:max-w-[85%]">
            <div
              className="leading-loose"
              style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "clamp(11px, 1.5vw, 21px)", color: "#111111" }}
            >
              ホームページを作っても問い合わせが来ない。<br />
              広告を出しても費用対効果が見えない。<br />
              SEOに取り組んでも順位が上がらない。<br />
              ——そのひとつひとつに、原因があります。<br /><br />
              CRUPLIXは、あなたのビジネスの現状・目標・予算を<br />
              ヒアリングしたうえで、必要な施策だけを組み合わせた戦略を設計。<br />
              <br />
              制作から集客・運用改善まで、ひとつの窓口で一気通貫で実行します。
            </div>
            <div className="mt-10 md:mt-14 pt-8 md:pt-10" style={{ borderTop: "1px solid rgba(0,0,0,0.1)" }}>
              <p
                className="font-bold leading-relaxed whitespace-nowrap"
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                  fontSize: "clamp(13px, 1.6vw, 20px)",
                  color: "#c00000",
                }}
              >
                「なんとなくやる」ではなく、「あなたに合った形で」。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Service Text Content ── */
function ServiceTextContent({
  s,
}: {
  s: (typeof services)[0];
}) {
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(60px)";
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transition = "opacity 0.9s cubic-bezier(0.16,1,0.3,1), transform 0.9s cubic-bezier(0.16,1,0.3,1)";
          el.style.opacity = "1";
          el.style.transform = "translateY(0)";
          obs.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const bodyParagraphs = s.body
    .split(/(?<=。)/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div ref={textRef} className="py-16 md:py-20 lg:py-24">
      <div className="flex flex-col gap-4 md:gap-6 lg:gap-8">
        {/* 上段：タイトル群 + リード文 */}
        <div className="w-full flex flex-col shrink-0">
          <div>
            <div className="mb-4">
              <span
                style={{
                  fontFamily: "'Barlow', sans-serif",
                  fontSize: "clamp(11px, 1.1vw, 16px)",
                  letterSpacing: "0.08em",
                  color: "#111111",
                }}
              >
                Service{" "}
                <span style={{ color: "#c00000", fontWeight: 600 }}>{s.num}</span>
              </span>
            </div>
            <div className="mb-5" style={{ letterSpacing: "0.02em" }}>
              <span
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                  fontSize: "clamp(24px, 4.2vw, 52px)",
                  color: "#111111",
                  fontWeight: 700,
                  display: "inline-block",
                  marginBottom: "8px",
                }}
              >
                {s.title}
              </span>
            </div>
          </div>

          <div className="mt-0 md:mt-1">
            <h3
              className="leading-tight"
              style={{
                fontFamily: "'Noto Sans JP', sans-serif",
                fontSize: "clamp(17px, 2vw, 26px)",
                fontWeight: 600,
                color: "#333333",
                letterSpacing: "-0.01em",
              }}
            >
              {s.lead}
            </h3>
          </div>
        </div>

        {/* 下段：説明文（全幅） */}
        <div className="w-full">
          {bodyParagraphs.map((p, i) => (
            <p
              key={i}
              className="mb-4 last:mb-0"
              style={{
                fontFamily: "'Noto Sans JP', sans-serif",
                fontSize: "clamp(11px, 1.5vw, 18px)",
                lineHeight: "1.7",
                color: "#333333",
              }}
            >
              {p}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Service Section ── */
function ServiceSection({
  s,
}: {
  s: (typeof services)[0];
}) {
  return (
    <div
      id={`svc-${s.num}`}
      className="relative"
      style={{
        borderBottom: "2px solid rgba(192,0,0,0.15)",
        marginBottom: "64px",
      }}
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-0">
        <ServiceTextContent s={s} />
      </div>
    </div>
  );
}

/* ── Scroll Progress Bar ── */
function ScrollProgressBar() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(total > 0 ? window.scrollY / total : 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] h-0.5 pointer-events-none"
      style={{ background: "rgba(0,0,0,0.06)" }}
    >
      <div
        className="h-full"
        style={{
          background: "#c00000",
          width: `${progress * 100}%`,
          transition: "width 0.1s linear",
        }}
      />
    </div>
  );
}

/* ── Service TOC (Right sidebar) ── */
function ServiceTOC({ activeIndex }: { activeIndex: number }) {
  const handleClick = (num: string) => {
    const el = document.getElementById(`svc-${num}`);
    if (el) {
      const offset = 100;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div>
      <nav className="flex flex-col">
        {services.map((s, i) => {
          const isActive = activeIndex === i;
          return (
            <button
              key={s.num}
              onClick={() => handleClick(s.num)}
              className="text-left cursor-pointer focus:outline-none w-full py-3 transition-all duration-300 flex items-center gap-2"
              style={{
                background: "transparent",
                border: "none",
                borderLeft: isActive ? "2px solid #c00000" : "2px solid transparent",
                paddingLeft: isActive ? "12px" : "14px",
              }}
            >
              <span
                className="inline-block rounded-full transition-all duration-300"
                style={{
                  width: "6px",
                  height: "6px",
                  background: isActive ? "#c00000" : "transparent",
                  flexShrink: 0,
                }}
              />
              <span
                className="leading-snug block"
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                  fontSize: "13px",
                  color: isActive ? "#111111" : "#aaaaaa",
                  fontWeight: isActive ? 500 : 400,
                  transition: "color 0.3s ease",
                }}
              >
                {s.tocName}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}

/* ── Main ── */
export default function ServicePage() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 2;
      let found = 0;
      for (let i = 0; i < services.length; i++) {
        const el = document.getElementById(`svc-${services[i].num}`);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          if (scrollPos >= top) {
            found = i;
          }
        }
      }
      setActiveIndex(found);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <PageLayout>
      <ScrollProgressBar />
      <ApproachSection />
      <TriangleApproach />

      <section className="relative" style={{ background: "#f5f4f2" }}>
        <div className="max-w-[1300px] mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-start">
            {/* Left - Service sections */}
            <div className="flex-1 min-w-0">
              {services.map((s) => (
                <ServiceSection key={s.num} s={s} />
              ))}
            </div>

            {/* Right - TOC */}
            <div className="hidden lg:block w-[200px] shrink-0 py-16 pl-8 lg:self-stretch">
              <div className="sticky top-28">
                <ServiceTOC activeIndex={activeIndex} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <DiagnosisSection theme="light" />
      <HomeFooter />
      <DiagonalLines variant="gold" intensity="light" />
    </PageLayout>
  );
}